import { computed, } from 'vue';
import { i18n } from '@/locales';
import { trimTextField } from '@/utils';
import { isRequired, isRequiredZeroAvailable, } from './index';
export const createOperationSettingFormRule = () => ({
    surchargeReason: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v))
                    || i18n.t('form_rules.value_require'),
            ];
        },
        set() { },
    }),
    surchargeCharge: computed({
        get() {
            return [
                (v) => isRequiredZeroAvailable(v)
                    || i18n.t('form_rules.value_require'),
            ];
        },
        set() { },
    }),
    surchargeChargeRate: computed({
        get() {
            return [
                (v) => isRequiredZeroAvailable(v)
                    || i18n.t('form_rules.value_require'),
            ];
        },
        set() { },
    }),
    delayReason: computed({
        get() {
            return [
                (v) => isRequired(trimTextField(v))
                    || i18n.t('form_rules.value_require'),
            ];
        },
        set() { },
    }),
    delayTime: computed({
        get() {
            return [
                (v) => isRequired(v)
                    || i18n.t('form_rules.value_require'),
            ];
        },
        set() { },
    }),
    stopReason: computed({
        get() {
            return [
                (v) => isRequired(v)
                    || i18n.t('form_rules.value_require'),
            ];
        },
        set() { },
    }),
});
/**
 * 이는 submit 이후에만 작동합니다.
 * 포커스 여부에 따라 두 값을 판단 후 에러 메세지를 반환합니다.
 */
export const linkedFieldErrorRule = (_val1, _val2, focused, isSubmitted) => ({
    bothFieldAreZero: computed({
        get() {
            return [
                isSubmitted.value && !focused.value && _val1.value === 0 && _val2.value === 0
                    ? i18n.t('form_rules.greater_than_target_value', [
                        0,
                    ])
                    : true,
            ];
        },
        set() { },
    }),
});
